import { Dialog } from '@headlessui/react'
import { XIcon } from '@heroicons/react/outline'
import { MiniGrid } from '../mini-grid/MiniGrid'
import { shareStatus } from '../../lib/share'
import { BaseModal } from './BaseModal'
import { NextWirdCountdown } from '../misc/NextWirdCountdown'
import { SHARE_TEXT, SUPPORT_US_TEXT } from '../../constants/strings'
import { ShowMeaning } from '../misc/ShowMeaning'

type Props = {
  isOpen: boolean
  handleClose: () => void
  guesses: string[]
  solution: string
  handleShare: () => void
  isHardMode: boolean
}

export const LoseModal = ({
  isOpen,
  handleClose,
  guesses,
  solution,
  handleShare,
  isHardMode,
}: Props) => {
  return (
    <BaseModal title="" isOpen={isOpen} handleClose={handleClose}>
      <div>
        <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
          <XIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
        </div>
        <div className="mt-3 text-center sm:mt-5">
          <Dialog.Title
            as="h3"
            className="text-lg leading-6 font-medium text-gray-900 dark:text-gray-100"
          >
            <p className="text-sm text-gray-900 dark:text-gray-100">
              حظاً أوفر في المرة القادمة!
            </p>
            <ShowMeaning word={solution}></ShowMeaning>
          </Dialog.Title>
          <div className="mt-2">
            <MiniGrid guesses={guesses} />
          </div>
        </div>
      </div>
      <NextWirdCountdown></NextWirdCountdown>
      <div className="mt-5 sm:mt-6">
        <button
          type="button"
          className="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-semibold text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
          onClick={() => {
            shareStatus(guesses, true, isHardMode)
            handleShare()
          }}
        >
          {SHARE_TEXT}
        </button>
        <button
          type="button"
          className="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-semibold text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm my-2.5"
        >
          {SUPPORT_US_TEXT}
        </button>
      </div>
    </BaseModal>
  )
}
